import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import { immerable, produce } from 'immer';
import { Map, Set } from 'immutable';

import { RankingItemEntity } from './ranking-item.entity';

export interface IRankingListExtra
	extends IListColumnConfig<RankingItemEntity> {
	width?: string | number;
	filterValue?: Array<string | number>;
	filterValues?: Array<string | number>;
	sortIndex?: number;
	sortOrder?: 'asc' | 'desc';
}

interface IRankingListEntity extends IListAttrs<RankingItemEntity> {
	availableColumns: Map<string, IRankingListExtra>;
}

const entityDefaults: IRankingListEntity = {
	elements: Map(),
	availableColumns: Map(),
};

export class RankingListEntity
	implements
		IRankingListEntity,
		IListOperations<RankingListEntity, RankingItemEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;

	public static build(
		availableCols: Array<IRankingListExtra>
	): RankingListEntity {
		const inst = new RankingListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, IRankingListExtra]>());
		inst.availableColumns = Map(cols);
		return inst;
	}

	private constructor() {}

	public getAvailableColumns(): Map<
		string,
		IListColumnConfig<RankingItemEntity>
	> {
		return this.availableColumns;
	}

	public setElements(elems: Map<string, RankingItemEntity>): RankingListEntity {
		return produce(this, (draft: RankingListEntity) => {
			draft.elements = elems;
		});
	}

	public extractUniqTags(): Set<string> {
		return this.elements.reduce((acc, rankingItem) => {
			if (!rankingItem.tags) {
				return acc;
			}
			return Set([
				...acc.toArray(),
				...rankingItem.tags
					.toList()
					.toArray()
					.map((l) => l.label),
			]);
		}, Set<string>());
	}

	public extractModifiers(): Set<string> {
		return this.elements.reduce((acc, rankingItem) => {
			if (rankingItem.updatedByAvatar && rankingItem.updatedByAvatar?.name) {
				acc = acc.add(rankingItem.updatedByAvatar.name);
			}
			return acc;
		}, Set<string>());
	}

	public extractActionCreators(): Set<string> {
		return this.elements.reduce((acc, rankingItem) => {
			if (rankingItem.createdByAvatar && rankingItem.createdByAvatar.name) {
				acc = acc.add(rankingItem.createdByAvatar.name);
			}
			return acc;
		}, Set<string>());
	}
}
